import * as Sentry from '@sentry/browser'
import { getSentryConfig, getSentryUser } from '../lib/sentry'

const sentryConfig = getSentryConfig()
if (sentryConfig) {
  Sentry.init({
    ...sentryConfig,
    integrations: [Sentry.browserTracingIntegration({ enableLongAnimationFrame: false })],
    tracesSampleRate: 0.01,
  })

  const user = getSentryUser()
  if (user) {
    Sentry.setUser(user)
  }
}

// this pack loads on every page, the admin included (ahead of the admin pack)
import "../lib/request_submit_polyfill"
import "controllers"
